import { SchedulesSearchSlot, SlotStatus } from '@/app/(main)/(pages)/busca/[slug]/_types/search-partner-data.type';
import { dateFormatter } from '@/utils/formatters/date';
import { formatToTitleCase } from '@/utils/formatters/format-to-title-case';
import { periodIntervalFormatter } from '@/utils/periods-formats.util';

function toLocalDate(timestamp: string): Date {
  return new Date(timestamp.slice(0, -1));
}

function toSortableDay(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const dayOfMonth = String(date.getDate()).padStart(2, '0');

  return `${date.getFullYear()}-${month}-${dayOfMonth}`;
}

export function groupByDateToTimeGrid(slots?: SchedulesSearchSlot[], today: Date = new Date()): TimeGrid[] {
  if (!slots) {
    return [];
  }

  const slotsByDay = slots.reduce(
    (acc, slot) => {
      if (slot.status !== SlotStatus.AVAILABLE) {
        return acc;
      }

      const day = toSortableDay(toLocalDate(slot.date));
      acc[day] = [...(acc[day] ?? []), slot];

      return acc;
    },
    {} as Record<string, SchedulesSearchSlot[]>,
  );

  return Object.keys(slotsByDay)
    .sort()
    .map((sortableDay) => {
      const daySlots = [...slotsByDay[sortableDay]].sort(
        (slotA, slotB) => toLocalDate(slotA.start).getTime() - toLocalDate(slotB.start).getTime(),
      );
      const day = toLocalDate(daySlots[0].date);
      const isToday = toSortableDay(day) === toSortableDay(today);

      return {
        day: day.toLocaleDateString('pt-br', { day: '2-digit', month: '2-digit' }),
        weekday: isToday
          ? 'Hoje'
          : formatToTitleCase(day.toLocaleDateString('pt-br', { weekday: 'short' })).slice(0, -1),
        times: daySlots.map((slot) => dateFormatter(slot.start, 'time')),
        timesPeriod: daySlots.map((slot) => periodIntervalFormatter({ start: slot.start, end: slot.end })),
      };
    });
}

export interface TimeGrid {
  day: string;
  weekday: string;
  times: string[];
  timesPeriod: string[];
}

export function formatVisibleGrid(slots: TimeGrid[], rows: number, showAll: boolean) {
  if (showAll) {
    return slots;
  }

  return slots.map((slot) => {
    return { ...slot, times: slot.times.slice(0, rows), timesPeriod: slot.timesPeriod.slice(0, rows) };
  });
}
